import { render, staticRenderFns } from "./TipoVehiculoExport.vue?vue&type=template&id=6619afe2"
import script from "./TipoVehiculoExport.vue?vue&type=script&lang=js"
export * from "./TipoVehiculoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports